const CustomModal = ({
   title,
   showModal,
   handleCloseModal,
   child,
   modalSize,
   modalHeight = "70vh",
   onSubmit,
   hideFooter,
}) => {
   return (
      <>
         {showModal && (
            <div
               className="modal-backdrop fade show"
               style={{ backdropFilter: "blur(5px)" }} // optional blur effect
            />
         )}
         <div
            className={`modal fade ${showModal ? "show d-block" : ""}`}
            id="modal-default"
            tabIndex="-1"
            role="dialog"
         >
            <div className={`modal-dialog ${modalSize}`} role="document">
               <div className="modal-content">
                  <div className="modal-header">
                     <h4 className="modal-title">{title}</h4>
                     <button
                        type="button"
                        className="close"
                        aria-label="Close"
                        onClick={handleCloseModal}
                     >
                        <span aria-hidden="true">×</span>
                     </button>
                  </div>
                  <div
                     className="modal-body"
                     style={{ maxHeight: modalHeight, overflowY: "auto" }}
                  >
                     {child}
                  </div>
                  {!hideFooter && (
                     <div className="modal-footer justify-content-center">
                        <button
                           type="button"
                           className="btn btn-primary"
                           onClick={() => {
                              if (onSubmit) {
                                 onSubmit();
                              } else {
                                 handleCloseModal();
                              }
                           }}
                        >
                           Submit
                        </button>
                     </div>
                  )}
               </div>
            </div>
         </div>
      </>
   );
};


export default CustomModal;
